import React from 'react'
import Featurecard from './Featurecard'
import './components.css'

const WonderGameSlider = ({ features }) => {
    // console.log(features)

    return (
        <div>
            <div className='flex-container'>
                {
                    features.map(feature => (
                        <div className='card'>
                            <Featurecard image={feature.benefit_logo_game} title={feature.benefit_title_game} />
                        </div>
                    ))
                }
            </div>
        </div >
    )
}

export default WonderGameSlider